var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "top-btn" },
      [
        _c(
          "vxe-button",
          { attrs: { status: "success" }, on: { click: _vm.returnToLevel } },
          [_vm._v("返回")]
        ),
      ],
      1
    ),
    _c("div", { staticClass: "table-container" }, [
      _c("table", [
        _c("tr", [
          _c("th", { staticStyle: { width: "130px" } }, [_vm._v("经销单位：")]),
          _c("td", { staticClass: "white-background" }, [
            _vm._v(_vm._s(_vm.form.org_id_text)),
          ]),
          _c("th", { staticStyle: { width: "120px" } }, [_vm._v("活动类型：")]),
          _c(
            "td",
            {
              staticClass: "white-background",
              staticStyle: { width: "120px" },
            },
            [_vm._v(_vm._s(_vm.form.hd_type_text))]
          ),
          _c("th", { staticStyle: { width: "120px" } }, [_vm._v("参加人数：")]),
          _c(
            "td",
            {
              staticClass: "white-background",
              staticStyle: { width: "120px" },
            },
            [_vm._v(_vm._s(_vm.form.customer_num) + "人")]
          ),
          _c(
            "td",
            { staticStyle: { width: "440px" }, attrs: { colspan: "5" } },
            [
              _c("a-button", { attrs: { type: "link" } }, [
                _vm._v("活动开展申请表"),
              ]),
            ],
            1
          ),
          _c(
            "th",
            { staticClass: "white-background", attrs: { colspan: "2" } },
            [_vm._v("申请时间：" + _vm._s(_vm.form.cdate))]
          ),
        ]),
        _vm._m(0),
        _c("tr", [
          _c("td", [_vm._v("支出费用：")]),
          _c("td", [_vm._v(_vm._s(_vm.form.yf))]),
          _c("td", [_vm._v(_vm._s(_vm.form.gqglf))]),
          _c("td", [_vm._v(_vm._s(_vm.form.hwf))]),
          _c("td", [_vm._v(_vm._s(_vm.form.bzf))]),
          _c("td", [_vm._v(_vm._s(_vm.form.cdzj))]),
          _c("td", [_vm._v(_vm._s(_vm.form.jzlwf))]),
          _c("td", [_vm._v(_vm._s(_vm.form.lpf))]),
          _c("td", [_vm._v(_vm._s(_vm.form.clbx))]),
          _c("td", [_vm._v(_vm._s(_vm.form.qtfy))]),
          _c("td", [_vm._v(_vm._s(_vm.form.qtfy))]),
          _c("td", { attrs: { rowspan: "2" } }, [
            _vm._v(_vm._s(_vm.form.lq_price)),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v("审核费用：")]),
          _c("td", [_vm._v(_vm._s(_vm.form.yf_audit))]),
          _c("td", [_vm._v(_vm._s(_vm.form.gqglf_audit))]),
          _c("td", [_vm._v(_vm._s(_vm.form.hwf_audit))]),
          _c("td", [_vm._v(_vm._s(_vm.form.bzf_audit))]),
          _c("td", [_vm._v(_vm._s(_vm.form.cdzj_audit))]),
          _c("td", [_vm._v(_vm._s(_vm.form.jzlwf_audit))]),
          _c("td", [_vm._v(_vm._s(_vm.form.lpf_audit))]),
          _c("td", [_vm._v(_vm._s(_vm.form.clbx_audit))]),
          _c("td", [_vm._v(_vm._s(_vm.form.qtfy_audit))]),
          _c("td", [_vm._v(_vm._s(_vm.form.qtfy_audit))]),
        ]),
        _vm._m(1),
        _c("tr", [
          _c("td", { staticClass: "align-right", attrs: { colspan: "2" } }, [
            _vm._v("活动总结："),
          ]),
          _c(
            "td",
            { attrs: { colspan: "11" } },
            [
              _c("a-button", { attrs: { type: "link" } }, [
                _vm._v(_vm._s(_vm.form.hdzj)),
              ]),
            ],
            1
          ),
        ]),
        _c("tr", [
          _c("td", { staticClass: "align-right", attrs: { colspan: "2" } }, [
            _vm._v("活动照片："),
          ]),
          _c(
            "td",
            { attrs: { colspan: "11" } },
            [
              _c("a-button", { attrs: { type: "link" } }, [
                _vm._v(_vm._s(_vm.form.hdzp)),
              ]),
            ],
            1
          ),
        ]),
        _c("tr", [
          _c("td", { staticClass: "align-right", attrs: { colspan: "2" } }, [
            _vm._v("签到表原件："),
          ]),
          _c(
            "td",
            { attrs: { colspan: "11" } },
            [
              _c("a-button", { attrs: { type: "link" } }, [
                _vm._v(_vm._s(_vm.form.qdbyj)),
              ]),
            ],
            1
          ),
        ]),
        _c("tr", [
          _c("td", { staticClass: "align-right", attrs: { colspan: "2" } }, [
            _vm._v("发票："),
          ]),
          _c(
            "td",
            { attrs: { colspan: "11" } },
            [
              _c("a-button", { attrs: { type: "link" } }, [
                _vm._v(_vm._s(_vm.form.fp)),
              ]),
            ],
            1
          ),
        ]),
        _c("tr", [
          _c("td", { staticClass: "align-right", attrs: { colspan: "2" } }, [
            _vm._v("产品展示情况表："),
          ]),
          _c(
            "td",
            { attrs: { colspan: "16" } },
            [
              _c("a-button", { attrs: { type: "link" } }, [
                _vm._v(_vm._s(_vm.form.ddzsqk)),
              ]),
            ],
            1
          ),
        ]),
        _c("tr", [
          _c(
            "td",
            { attrs: { colspan: "18" } },
            [
              _c("a-button", { attrs: { type: "link" } }, [
                _vm._v("参加活动客户明细"),
              ]),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticStyle: { "margin-top": "30px" } },
      [
        _c(
          "vxe-table",
          {
            attrs: {
              loading: _vm.listLoading,
              border: "",
              resizable: "",
              height: "300",
              align: _vm.allAlign,
              data: _vm.tableData,
            },
          },
          [
            _c("vxe-table-column", {
              attrs: { type: "seq", width: "60", title: "序号" },
            }),
            _c("vxe-table-column", {
              attrs: { field: "user_name", width: "200", title: "审核人" },
            }),
            _c("vxe-table-column", {
              attrs: { field: "audit_time", width: "200", title: "审核日期" },
            }),
            _c("vxe-column", {
              attrs: { field: "audit_idear", title: "意见" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(row.audit_idear) },
                      }),
                    ]
                  },
                },
              ]),
            }),
            _c("vxe-table-column", {
              attrs: { field: "status_name", width: "100", title: "状态" },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "note" }, [
          _vm._v(" 注：标有 * 的标识为必填项 "),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", { attrs: { rowspan: "3" } }, [_vm._v("费用支出明细：")]),
      _c("td", [_vm._v("支出项目：")]),
      _c("td", [_vm._v("油费（柴油）")]),
      _c("td", [_vm._v("过桥过路费")]),
      _c("td", [_vm._v("会务费")]),
      _c("td", [_vm._v("布展费")]),
      _c("td", [_vm._v("场地租金")]),
      _c("td", [_vm._v("记者劳务费")]),
      _c("td", [_vm._v("礼品费")]),
      _c("td", [_vm._v("车辆保险")]),
      _c("td", [_vm._v("其他费用")]),
      _c("td", [_vm._v("支出合计")]),
      _c("td", [_vm._v("柳汽报销费用")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "2" } }, [_vm._v("报账资料：")]),
      _c("td", { attrs: { colspan: "11" } }, [_vm._v("上传附件文件")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }